import { render } from "./ChatIcon.vue?vue&type=template&id=0b6a283a"
import script from "./ChatIcon.vue?vue&type=script&lang=js"
export * from "./ChatIcon.vue?vue&type=script&lang=js"

import "./ChatIcon.vue?vue&type=style&index=0&id=0b6a283a&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__